import { render, staticRenderFns } from "./institutionList.vue?vue&type=template&id=3016ac72"
import script from "./institutionList.vue?vue&type=script&lang=js"
export * from "./institutionList.vue?vue&type=script&lang=js"
import style0 from "./institutionList.vue?vue&type=style&index=0&id=3016ac72&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports